import { Component, OnInit } from '@angular/core';
import { authManager } from '@authmanager/authManager';
import { AdminService } from '@adminservice/admin.service';
import { environment } from '@environment/environment';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  public userloggedin: string;
  loggedinUserSSO: number;
  UserLogStatus: any;
  LognewUser: any = {};
  userstatus: any;
  public Info: number;
  displayHelpPopUp: any;
  public Internaluser: any;
  public loggedinUser: any;

  public userRoleId: number;

  userID: any;
  unAuthorizedUser: boolean;
  dropdownOpen = false;

  constructor(private AuthManager: authManager, private adminService: AdminService, private router: Router, ) {
    this.userloggedin = '';
    this.Internaluser = sessionStorage.getItem('userRoleId');

    this.userID = this.AuthManager.userDetailsFromDb;
    
    if (Number(this.Internaluser) > 0) {
      if (this.AuthManager.dynSSOId === '-1') {
        this.loggedinUserSSO = Number(sessionStorage.getItem('userid'));
        this.userloggedin = sessionStorage.getItem('firstname') + ' ' + sessionStorage.getItem('lastname');
      } else {
        this.loggedinUserSSO = Number(this.AuthManager.dynSSOId);
        this.userloggedin = this.AuthManager.dynFirstName + ' ' + this.AuthManager.dynLastName;
      }
      this.Info = Number(sessionStorage.getItem('userRoleId'));
    } else {
      this.loggedinUser = sessionStorage.getItem('userid');
      this.userloggedin = sessionStorage.getItem('firstname') + ' ' + sessionStorage.getItem('lastname');
    }

    if (!sessionStorage.getItem('userRoleId')){

    if(this.userID == null) {
      this.unAuthorizedUser = true;
      setTimeout((router: Router) => {
              this.AuthManager.logoutUser();
            }, 10000);  // After 10 secs redirect to Login page
    }      
    else {
      this.unAuthorizedUser = false;
    }

    }

  }
  // Method to logout User
  logoutUser() {

    this.LognewUser.UserID = sessionStorage.getItem('userid');
    this.LognewUser.LogOutTime = new Date();
    this.LognewUser.Active = 0;
    // Method to store user's logout details
    this.adminService.UpdateLogOutTimeUserLog(this.LognewUser)
      .subscribe((status) => {
      this.UserLogStatus = status;
        this.AuthManager.logoutUser(); // Mthod to logout user
      });
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  closeDropdown() {
    this.dropdownOpen = false;
  }

  ExternalUser1() {

    sessionStorage.setItem('Invoice', '1');
    // window.location.href=environment.appurl+'/#/Invoice';
    this.router.navigate(['Invoice']);
  }

  ExternalUser2() {

    sessionStorage.setItem('Invoice', '2');
    // window.location.href=environment.appurl+'/#/Invoice';
    this.router.navigate(['Invoice2']);
  }

  ExternalUser3() {

    sessionStorage.setItem('Invoice', '3');
    // window.location.href=environment.appurl+'/#/Invoice';
    this.router.navigate(['Invoice3']);


  }
  ExternalUser4() {

    sessionStorage.setItem('Invoice', '4');
    // window.location.href=environment.appurl+'/#/Invoice';
    this.router.navigate(['Invoice4']);


  }
  ExternalUser5() {

    sessionStorage.setItem('Invoice', '5');
    // window.location.href=environment.appurl+'/#/Invoice';
    this.router.navigate(['Invoice5']);


  }
  ExternalUser6() {

    sessionStorage.setItem('Invoice', '6');
    // window.location.href=environment.appurl+'/#/Invoice';
    this.router.navigate(['Invoice6']);


  }
  ExternalUser7() {

    sessionStorage.setItem('Invoice', '7');
    // window.location.href=environment.appurl+'/#/Invoice';
    this.router.navigate(['Invoice7']);


  }
  Admin() {

    sessionStorage.setItem('Invoice', '7');
    // window.location.href=environment.appurl+'/#/Invoice';
    this.router.navigate(['Admin']);


  }
  HelpPopup() {
    this.displayHelpPopUp = true;
  }

  onClickOk() {
    this.displayHelpPopUp = false;
  }
  ChangePassword() {
    this.router.navigate(['ChangePassword']);
  }
  ExternalInvoice() {
    this.router.navigate(['Invoice']);
  }

  ngOnInit() {

    this.userRoleId = Number(sessionStorage.getItem('userRoleId'));

  }
  InternalInvoice() {
    this.router.navigate(['InternalInvoice']);
  }

  RefundHome() {
    sessionStorage.removeItem('selectedInvAgency');
    sessionStorage.removeItem('selectedOrderAgency');
    this.router.navigate(['TransactionRefund']);
  }

  RefundApproveHome() {
    sessionStorage.removeItem('selectedInvAgency');
    sessionStorage.removeItem('selectedOrderAgency');
    this.router.navigate(['RefundApprove']);
  }

}
